export function formatDateDDMMYYYYHHMM(time) {
  let date = new Date(time);
  return (
    date.toLocaleDateString() +
    " " +
    date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  );
}

export function formatDateDDMMYYYYT0000(time) {
  let date = new Date(time);
  return date.toISOString().split("T")[0] + "T00:00";
}

export function formatDateYYYYMMDD(time) {
  let date = new Date(time);
  return date.toISOString().split("T")[0];
}

export function formatDateHHMM(time) {
  let date = new Date(time);
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export function msToTime(duration) {
  var milliseconds = parseInt((duration % 1000) / 100),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return hours + ":" + minutes + ":" + seconds;
}
